import React, {useEffect} from 'react';
import {createContext, useContext, useState} from "react";
import {Toast} from "react-bootstrap";

export function CreateToastCtx(defaultValue) {
    const defaultUpdate = () => defaultValue;

    const toastCtx = createContext({
        toast: defaultValue,
        setToast: defaultUpdate
    });

    function TProvider(props) {
        const [toast, setToast] = useState(defaultValue);

        const [showToast, setShowToast] = useState(false);


        useEffect(() => {
            setShowToast(true);
            setTimeout(() => {
                setShowToast(false);
            }, 5000)
        }, [toast]);
        
        
        const generateClasses = () =>{
            if(toast.type === "error"){
                return "bg-danger text-white";
            }
            if(toast.type === "success"){
                return "bg-success text-white";
            }
        }
        
        return (
            <toastCtx.Provider value={{toast, setToast}}
                               {...props}>
                {props?.children}
                {showToast && (
                    <div className={"toast-container"} style={{minWidth: 250, maxWidth: 250}}>
                        <Toast className={generateClasses()}>
                            <Toast.Header className={generateClasses()}>
                                {toast.header}
                            </Toast.Header>
                            <Toast.Body className={generateClasses()}>
                                {toast.body}
                            </Toast.Body>
                        </Toast>
                    </div>
                )}
            </toastCtx.Provider>

        )
    }

    return [toastCtx, TProvider];
}


const [toastCtx, TProvider] = CreateToastCtx({
    header: "",
    body: ""
})

export const ToastContext = toastCtx;

export function ToastProvider({children}) {
    return <TProvider>{children}</TProvider>
}


export function UseToast() {
    return useContext(ToastContext);
}
